<template>
  <div>
    <template v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <!-- <p style="display: flex; align-items: center; gap: 5px">
              <span style="font-size: 14px; font-weight: 500">Filtri</span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                width="18"
              >
                <path
                  d="M960 682.7H527.3c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h134c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112s127.6-47.8 144-112c2.4-9.4 10.9-16 20.7-16h432.7c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3zm-597.3 128c-58.9 0-106.6-47.8-106.6-106.7s47.7-106.6 106.6-106.6 106.6 47.8 106.6 106.7-47.7 106.6-106.6 106.6zm298.6-341.4c69.4 0 127.6-47.8 144-112 2.4-9.4 10.9-16 20.7-16h134c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3H826c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h432.7c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112h0zm0-256c58.9 0 106.7 47.8 106.7 106.7s-47.8 106.7-106.7 106.7S554.6 378.9 554.6 320s47.8-106.7 106.7-106.7h0z"
                ></path>
              </svg>
            </p> -->
            <!-- <pre>{{ activeFilters }}</pre> -->
            <!-- v-for="(value, name, index) in computeActiveFilters" -->
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle.sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
        </b-button-group>
        <a
          class="btn btn--smaller btn--transparent"
          v-if="
            isAdmin() &&
            $store.state.auth.settings.attributables.LISALEX === 'Y'
          "
          :href="`http://${$store.state.auth.config_agency_name}${computeLisaLexDomain}?token=${$store.state.auth.token}`"
          target="_blank"
          title="Naviga su Lisalex"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 400 121.02"
            height="20"
            fill="#9a1c20"
          >
            <path
              d="M60.53,0C27.1,0,.02,27.12.02,60.51s27.12,60.51,60.51,60.51,60.51-27.12,60.51-60.51S93.97,0,60.53,0ZM84.56,94.81h-41.75c-5.59,0-10.08-4.5-10.08-10.08V31.89c0-5.59,4.5-10.08,10.08-10.08s10.08,4.5,10.08,10.08v42.75h31.66c5.59,0,10.08,4.5,10.08,10.08s-4.5,10.08-10.08,10.08Z"
            />

            <path
              d="M148.98 92.67c-4.19 0-6.29-1.59-6.29-4.78V35.11c0-3.42 2.13-5.14 6.38-5.14 1.53 0 2.91.37 4.12 1.11s1.81 1.96 1.81 3.68v52.96c0 1.77-.53 3.04-1.59 3.81-1.06.76-2.54 1.15-4.43 1.15z"
            />

            <path
              d="M173.68 27.84c1.71 0 3.29.53 4.74 1.6 1.44 1.06 2.17 2.72 2.17 4.96 0 2.01-.63 3.6-1.9 4.78s-2.94 1.77-5 1.77-3.73-.59-5-1.77-1.91-2.77-1.91-4.78c0-1.89.63-3.45 1.91-4.7 1.27-1.24 2.94-1.86 5-1.86zm0 64.83c-4.19 0-6.29-1.59-6.29-4.78v-36.4c0-1.71.5-3.07 1.51-4.07 1.01-1.01 2.63-1.51 4.87-1.51 1.89 0 3.35.41 4.38 1.24s1.55 2.1 1.55 3.81v36.75c0 1.77-.53 3.04-1.59 3.81-1.06.76-2.54 1.15-4.43 1.15zm54.46-14c0 4.96-1.8 8.68-5.4 11.16s-8.5 3.72-14.7 3.72c-3.54 0-6.72-.41-9.52-1.24s-5.06-1.86-6.77-3.1c-.77-.53-1.34-1.14-1.73-1.82s-.58-1.34-.58-1.99c0-1.18.3-2.3.89-3.37.47-.89 1.08-1.63 1.82-2.21.74-.59 1.61-.89 2.61-.89.88 0 1.74.26 2.57.8l2.79 1.77c1.03.65 2.23 1.24 3.59 1.77 1.35.53 3.07.8 5.13.8 2.54 0 4.37-.41 5.49-1.24s1.68-1.95 1.68-3.37c0-1.06-.4-2.04-1.2-2.92s-2.44-1.53-4.91-1.95l-5.31-.89c-2.19-.36-4.18-.87-5.98-1.55s-3.35-1.56-4.65-2.66c-1.3-1.09-2.3-2.42-3.01-3.99-.71-1.56-1.06-3.47-1.06-5.71 0-2.36.47-4.46 1.42-6.29.94-1.83 2.27-3.38 3.99-4.65 1.71-1.27 3.77-2.23 6.15-2.88 2.39-.65 5-.97 7.84-.97 4.13 0 7.5.49 10.1 1.46 2.59.97 4.51 1.96 5.75 2.97.77.65 1.3 1.3 1.6 1.95.29.65.44 1.3.44 1.95 0 1.42-.38 2.63-1.15 3.63-.47.59-.96 1.05-1.46 1.37s-1.14.49-1.9.49c-.65 0-1.32-.13-1.99-.4-.68-.26-1.25-.54-1.73-.84-1.6-.94-3.13-1.71-4.6-2.3-1.48-.59-3.39-.89-5.76-.89s-4 .4-5.09 1.2-1.64 1.79-1.64 2.97c0 1.06.4 1.99 1.19 2.79s2.53 1.43 5.18 1.91l4.7.89c5.37 1 9.25 2.6 11.64 4.78s3.59 5.43 3.59 9.74zm48.08 9.12c0 1.72-.43 2.95-1.28 3.72-.86.76-2.32 1.15-4.39 1.15-1.77 0-3.17-.37-4.2-1.11s-1.55-1.99-1.55-3.77v-1.59a32.07 32.07 0 0 1-2.17 2.48c-.8.83-1.77 1.56-2.92 2.22-1.15.65-2.5 1.18-4.03 1.59s-3.3.62-5.31.62c-4.67 0-8.34-1.23-11.03-3.68s-4.03-5.71-4.03-9.79c0-2.36.4-4.37 1.2-6.02s1.89-3.04 3.28-4.16 3.01-2.01 4.87-2.66 3.82-1.15 5.89-1.51c2.24-.41 4.5-.74 6.77-.97 2.27-.24 4.74-.44 7.39-.62v-1.68c0-.89-.12-1.76-.35-2.61-.24-.86-.63-1.64-1.2-2.35-.56-.71-1.34-1.27-2.35-1.68s-2.24-.62-3.72-.62c-.95 0-1.82.06-2.61.18a12.28 12.28 0 0 0-2.3.57c-.74.27-1.51.64-2.3 1.11a71.19 71.19 0 0 0-2.7 1.68 22.02 22.02 0 0 1-2.17 1.33c-.68.35-1.52.53-2.52.53-1.36 0-2.57-.52-3.63-1.55a5.06 5.06 0 0 1-1.59-3.77c0-1 .41-2.08 1.24-3.23s2.08-2.21 3.76-3.19c1.68-.97 3.75-1.78 6.2-2.44 2.45-.65 5.33-.97 8.64-.97 6.79 0 11.67 1.33 14.65 3.99s4.47 6.79 4.47 12.4v26.39zm-11.51-16.64c-2.24.24-4.38.5-6.42.8s-3.56.56-4.56.8c-2.84.59-4.68 1.43-5.53 2.53-.86 1.09-1.29 2.2-1.29 3.32 0 1.54.47 2.73 1.42 3.59.94.85 2.57 1.28 4.87 1.28 3.66 0 6.49-.84 8.5-2.52 2-1.68 3.01-3.85 3.01-6.51v-3.28z"
            />

            <path
              d="M294.91 92.67c-4.19 0-6.29-1.59-6.29-4.78V35.11c0-3.42 2.13-5.14 6.38-5.14 1.53 0 2.91.37 4.12 1.11s1.81 1.96 1.81 3.68v52.96c0 1.77-.53 3.04-1.59 3.81-1.06.76-2.54 1.15-4.43 1.15z"
            />

            <path
              d="M334.05 45.02c6.44 0 11.56 1.99 15.36 5.98s5.71 9.7 5.71 17.13c0 1.72-.52 2.89-1.55 3.55-1.03.65-2.49.97-4.38.97h-25.68c.59 7.26 4.51 10.89 11.78 10.89 1.89 0 3.48-.31 4.78-.93l3.37-1.64a39.84 39.84 0 0 0 2.48-1.42c.77-.48 1.68-.71 2.75-.71 1.18 0 2.27.59 3.28 1.77s1.51 2.51 1.51 3.99c0 1.06-.31 1.99-.93 2.79s-1.64 1.64-3.06 2.52c-1.89 1.18-4.15 2.08-6.77 2.7s-5.21.93-7.75.93c-3.66 0-6.98-.48-9.96-1.42s-5.51-2.39-7.57-4.34c-2.07-1.95-3.66-4.41-4.78-7.39s-1.68-6.51-1.68-10.58a31.82 31.82 0 0 1 1.33-9.16c.89-2.98 2.27-5.62 4.16-7.93 1.89-2.3 4.3-4.16 7.22-5.58s6.39-2.13 10.41-2.13zm8.76 18.51c0-1.06-.18-2.13-.53-3.19a8.99 8.99 0 0 0-1.64-2.92c-.74-.88-1.67-1.6-2.79-2.13s-2.48-.8-4.08-.8c-2.54 0-4.73.77-6.6 2.3-1.86 1.53-2.94 3.78-3.23 6.73h18.86zm55.97 20.64c.83 1.12 1.24 2.27 1.24 3.45 0 1.24-.59 2.39-1.77 3.46s-2.75 1.59-4.7 1.59c-1.59 0-2.85-.44-3.76-1.33-.92-.88-1.64-1.68-2.17-2.39l-8.24-11.07-8.94 11.69c-.65.83-1.34 1.55-2.08 2.17s-1.85.93-3.32.93c-2.01 0-3.59-.58-4.74-1.73s-1.73-2.32-1.73-3.5c0-1.3.74-2.86 2.21-4.69l11.34-14.17L361.4 54.5c-.77-1.01-1.15-2.1-1.15-3.28a3.98 3.98 0 0 1 .53-1.99c.36-.62.84-1.18 1.46-1.68s1.34-.9 2.17-1.2 1.71-.44 2.66-.44c1.36 0 2.41.32 3.15.97s1.49 1.51 2.26 2.57l7.17 9.83 7.08-9.56c.83-1.06 1.61-1.96 2.35-2.7s1.73-1.11 2.97-1.11c.94 0 1.83.15 2.66.44.83.3 1.53.7 2.13 1.2.59.5 1.06 1.05 1.42 1.64.35.59.53 1.15.53 1.68 0 1.18-.44 2.39-1.33 3.63l-10.63 13.9 11.95 15.76z"
            />
          </svg>
        </a>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'EXPOREGI',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
        <b-button
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="onAdd"
          title="Crea un nuovo cliente"
          :disabled="!canVerb(resource, 'store')"
        >
          <base-icon name="circled_plus" width="22" height="22" />
          <span>Crea</span>
        </b-button>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <template #header="{ hide }">
            <div class="inner-header">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo cliente </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea un nuovo cliente"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </div>
          </template>
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item" data-cols="2">
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="RFRNAME"
                  v-model="filter.byRegistry.title"
                  type="text"
                  :label="sidebarFilterName('byRegistry.title')"
                  placeholder="Inserisci un nominativo"
                />
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="status_registry"
                  label="Tipo Cliente"
                  v-model="filter.byAttribute.status_registry"
                  :options="statusRegistryOptions"
                />
                <!-- <div class="active-filter">
                  <span class="svg-wrapper">
                    <svg viewBox="0 0 16 16" width="16" height="16">
                      <circle
                        opacity="1"
                        cx="8"
                        cy="8"
                        r="8"
                        fill="currentColor"
                      ></circle>
                    </svg>
                  </span> -->
                <!-- <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    viewBox="0 0 16 16"
                  >
                    <circle
                      class="outer-circle"
                      cx="8"
                      cy="8"
                      r="8"
                      fill="currentColor"
                    />
                    <circle
                      class="inner-circle-1"
                      cx="8"
                      cy="8"
                      r="6"
                      fill="#fff"
                    />
                    <circle
                      class="inner-circle-2"
                      cx="8"
                      cy="8"
                      r="3.2"
                      fill="currentColor"
                    />
                  </svg> -->
                <!-- </div> -->
              </div>
              <div class="filter-item" data-type="registry-group">
                <div>
                  <b-button-toolbar>
                    <b-button-group>
                      <base-input
                        :class="{
                          'filter-item-inner-wrapped': true,
                        }"
                        name="Gruppo Anagrafico"
                        label="Gruppo Anagrafico"
                        v-model="form.inpt_label_group"
                        :readonly="true"
                      />
                      <b-button
                        class="btn-quick btn--light"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        title="Cerca gruppo anagrafico"
                        @click="openQuickSearchGroup"
                      >
                        <!-- <b-icon icon="search"></b-icon> -->
                        <base-icon
                          name="search"
                          width="14"
                          height="14"
                        ></base-icon>
                      </b-button>
                      <b-button
                        v-if="form.inpt_label_group"
                        class="btn--light btn--alert"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        @click="resetGroupId"
                        title="Elimina gruppo anagrafico"
                      >
                        <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                        <base-icon
                          name="trash"
                          width="22"
                          height="22"
                        ></base-icon>
                      </b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </div>
              <quick-search-group-modal
                ref="quickSearchGroup"
                @input="handleGroupModalInput"
              ></quick-search-group-modal>
              <div class="filter-item" data-type="registry-group-info">
                <div class="details-card-wrapper" v-if="extra_group_full_info">
                  <b-card>
                    <div
                      slot="header"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 d-inline-block align-middle">
                        <strong
                          >Informazioni gruppo anagrafico selezionato</strong
                        >
                      </p>
                    </div>
                    <div
                      class="custom-grid-wrapper"
                      v-html="extra_group_full_info"
                    ></div>
                  </b-card>
                </div>
              </div>
              <!-- <b-button-group
                v-b-toggle:collapse-1-inner
                class="my-2 filter-button-group"
              >
                <span class="when-open">
                  <b-icon icon="funnel" font-scale="1.5"></b-icon>
                </span>
                <span class="when-closed">
                  <b-icon icon="funnel" font-scale="1.5"></b-icon>
                </span>
                Filtri aggiuntivi
              </b-button-group> -->
              <!-- <b-collapse id="collapse-1-inner">
              </b-collapse> -->
              <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
              <div class="filter-item" data-cols="3">
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="SURN"
                  v-model="filter.byAttribute.SURN"
                  type="text"
                  label="Cognome"
                  placeholder="Inserisci un cognome"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="NAME"
                  v-model="filter.byAttribute.NAME"
                  type="text"
                  label="Nome"
                  placeholder="Inserisci un nome"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="CNAM"
                  v-model="filter.byAttribute.CNAM"
                  type="text"
                  label="Ragione Sociale"
                  placeholder="Inserisci una ragione sociale"
                />
              </div>
              <div class="filter-item">
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="salesman"
                  :label="sidebarFilterName('byBroker.id')"
                  v-model="filter.byBroker.id"
                  :options="salesmen_select"
                  :taggable="salesmen_taggable"
                  :multiple="true"
                  :closeOnSelect="false"
                  :defaultHtmlMultipleSelect="true"
                  @changeTaggable="changeTaggable"
                >
                  <template #advanced-actions>
                    <b-button
                      :pressed.sync="myToggle"
                      variant="light"
                      class="btn--smaller btn--x-smaller btn--transparent"
                      @click="
                        myToggle ? selectAllBrokers() : deselectAllBrokers()
                      "
                      >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                    </b-button>
                    <b-button
                      :pressed.sync="myTogglePO"
                      variant="light"
                      class="btn--smaller btn--x-smaller btn--transparent"
                      @click="
                        myTogglePO
                          ? salesmenOrderByCode()
                          : salesmenOrderByName()
                      "
                      >{{
                        myTogglePO ? "Ordine per nome" : "Ordina per codice"
                      }}
                    </b-button>
                  </template>
                </base-select>
                <base-checkbox
                  v-model="activeBrokerOnly"
                  name="activeBrokerOnly"
                  class="mt-4"
                  groupLabel=""
                  label="Per la determinazione del produttore considera solo le polizze attive"
                />
              </div>
              <div class="filter-item" data-cols="3">
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="attributables.NINO"
                  v-model="filter.byAttribute.NINO"
                  type="text"
                  :label="getDictionary('attribute_NINO_value', 'registry')"
                  placeholder="Inserisci un codice fiscale"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="creg"
                  v-model="filter.byAttribute.CREG"
                  type="text"
                  :label="getDictionary('attribute_CREG_value', 'registry')"
                  placeholder="Inserisci una partita IVA"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="prof"
                  v-model="filter.byAttribute.PROF"
                  type="text"
                  :label="getDictionary('attribute_PROF_value', 'registry')"
                  placeholder="Inserisci una professione"
                />
              </div>
              <div class="filter-item" data-cols="3">
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="PROVINCE"
                  label="Provincia"
                  v-model="filter.byProvince.id"
                  :options="opt_provinces"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                  @select="onSelectProvince"
                  @remove="onRemoveProvince"
                />
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="CITY"
                  label="Comune"
                  v-model="filter.byCorrespondence.CITY"
                  :options="opt_councils"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="CAP"
                  v-model="filter.byCorrespondence.ZIPC"
                  type="text"
                  :label="
                    getDictionary('attribute_ZIPC_value', 'correspondence')
                  "
                  maxlength="5"
                  placeholder="Inserisci un CAP"
                />
              </div>
              <div class="filter-item">
                <base-textarea
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="ADDR"
                  v-model="filter.byCustom.ADDR.value"
                  :label="
                    getDictionary('attribute_ADDR_value', 'correspondence')
                  "
                  placeholder="Inserisci un indirizzo"
                />
              </div>
              <div class="filter-item" data-cols="4">
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="note"
                  label="Note"
                  v-model="filter.byTask.task_type"
                  :options="[
                    { value: '2', text: 'Cerca solo clienti con note' },
                  ]"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="lisaweb_registries"
                  label="Anagrafiche Lisaweb"
                  v-model="filter.byManual"
                  :options="opt_anagrafiche_lisaweb"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
                <base-select
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="elenca"
                  label="Stato Portafoglio"
                  v-model="filter.byInsuranceStatus.value"
                  :options="statusInsuranceOptions"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                  :disabled="activeBrokerOnly"
                />
                <base-select
                  name="GDPR"
                  v-model="filter.byAttribute.GDPR"
                  type="text"
                  :label="getDictionary('attribute_GDPR_value', 'registry')"
                  :options="statusPrivacyOptions"
                />
              </div>
              <div class="mt-5" v-show="customFilters.length > 0">
                <h3 class="inner-filter-title">
                  Filtri sui "Campi Aggiuntivi"
                </h3>
                <custom-filter
                  v-for="(element, index) in customFilters.filter(
                    (e) => getInputType(e) === 'text',
                  )"
                  :key="`A${index}`"
                  v-model="filter.byCustom[element.key]['value']"
                  :element="element"
                />
                <custom-filter
                  v-for="(element, index) in customFilters.filter(
                    (e) => getInputType(e) !== 'text',
                  )"
                  :key="`B${index}`"
                  v-model="filter.byAttribute[element.key]"
                  :element="element"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca</b-button
              >
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset</b-button
              >
            </div>
          </b-form>
        </b-sidebar>
        <!-- <button-group-table
          @csv="onExport('csv')"
          :options="{
            CSV: { enabled: true },
          }"
        ></button-group-table> -->
        <table-registries
          @edit="onEdit"
          @destroy="onDestroy"
          @manualFetch="manualFetch"
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :filterName="filterName"
          :ref="tableRef"
          :performedSearch="computePerformedSearch"
          :filterCount="countActiveFilters"
          :filterOn="{
            byRelations: [
              'byRegistryGroup',
              'byInsurancePolicy',
              'byBroker',
              'byActiveBroker',
              'byTask',
              'byDocument',
              'byPrivacy',
            ],
          }"
          :onlyActions="['edit', 'infomodal', 'destroy']"
        ></table-registries>
      </div>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import { isAdmin } from "@/utils/permissions";
import TableRegistries from "@/components/tables/Registries";
import BaseIcon from "@/components/BaseIcon";
import ExportOptions from "@/components/ExportOptions";
import BaseTextarea from "@/components/form/BaseTextarea";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import { mapActions } from "vuex";
import CustomFilter from "@/components/form/CustomFilter";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { mapGetters } from "vuex";
import { toInfoData } from "@/utils/transforms";
import { getInputType } from "@/utils/forms";
import { computed } from "vue";
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
import { getDictionary } from "../../../utils/dictionary";
import BaseCheckbox from "../../form/BaseCheckbox.vue";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      defaultCountryId: null,
      defaultCountryName: "Italia",
      opt_provinces: [],
      opt_councils: [],
      ajaxOptions: [],
      isLoadingAjax: false,
      activeBrokerOnly: false,
      repository: "registry",
      resource: "registries",
      context: "registries",
      activeFilters: {},
      filterName: "filterRegistry",
      optProvince: null,
      performedSearch: false,
      statusInsuranceOptions: [
        { value: "yes", text: "Clienti con polizze attive" },
        { value: "no", text: "Clienti con polizze estinte" },
        { value: "without", text: "Clienti senza polizze" },
      ],
      filter: this.initFilter(),
      statusPrivacyOptions: [
        { text: "No", value: "no" },
        { text: "Sì", value: "yes" },
      ],
      notes: [],
      todos: [],
      appointments: [],
      documents: [],
      salesmen: [],
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      myToggle: false,
      myTogglePO: false,
      opt_anagrafiche_lisaweb: [{ value: "0", text: "Si" }],
      salesmen_taggable: true,
      statusRegistryOptions: [
        { text: "Persona Fisica", value: 0 },
        { text: "Persona Giuridica", value: 1 },
      ],
      tableRef: "RegistryTableRef",
      fields: [
        {
          key: "customer",
          value: (item) =>
            item.status_registry.value === 1
              ? item.attributables.CNAM
              : item.attributables.SURN + " " + item.attributables.NAME,
          label: this.getDictionary("customer_name"),
          sortable: true,
          sortKey: "title",
        },
        {
          key: "insurance_policy",
          value: (item) =>
            item.insurance_policies.length
              ? item.insurance_policies.length
              : "no pol",
          label: this.getDictionary("insurance_policies"),
        },
        {
          key: "status_registry",
          label: this.getDictionary("status_registry", "registry"),
          value: (item) => (item.status_registry.value === 1 ? "G" : "F"),
          sortable: false,
        },
        {
          key: "primary_group",
          value: (item) =>
            item.registry_groups.length
              ? item.registry_groups.find(
                  (registry_group) =>
                    registry_group.pivot.primary.value === "Y",
                ).code
              : "",
          label: this.getDictionary("Gruppo Primario"),
        },
        {
          key: "broker",
          value: (item) =>
            item.insurance_policies
              ? item.insurance_policies
                  .filter((e) => {
                    return e.broker && e.broker.status_broker.value === 0;
                  })
                  // filtrare solo quelle che si trovano in stati particolari:
                  // 0: non perfezionata,
                  // 1: perfezionata
                  // 2: sospesa
                  .filter((e) => {
                    return (
                      e.status_policy &&
                      [0, 1, 2].includes(e.status_policy.value)
                    );
                  })
                  .map((e) => e.broker.attributables.BUID)
                  .filter((value, index, e) => e.indexOf(value) === index)
                  .join(", ")
              : "",
          label: this.getDictionary("salesman"),
        },
        {
          key: "attributables.PROF",
          value: "attributables.PROF",
          label: this.getDictionary("attribute_PROF_value", "registry"),
          sortable: true,
          sortKey: "byAttribute.PROF",
        },
        {
          key: "attributables.NINO",
          value: "attributables.NINO",
          label: this.getDictionary("attribute_NINO_value", "registry"),
          sortable: true,
          sortKey: "byAttribute.NINO",
        },
        {
          key: "attributables.CREG",
          value: "attributables.CREG",
          label: this.getDictionary("attribute_CREG_value", "registry"),
          sortable: true,
          sortKey: "byAttribute.CREG",
        },
        {
          key: "privacy_disclaimers_questions",
          label: this.getDictionary("attribute_GDPR_value", "registry"),
          sortable: false,
          sortKey: "byAttribute.GDPR",
          // value: (item) => this.basicPrivacyCheck(item),
        },
        {
          key: "address",
          value: (item) => toInfoData(item, "address", 0),
          label: this.getDictionary("attribute_ADDR_value", "correspondence"),
          sortable: false,
        },
        {
          key: "address_books",
          label: this.getDictionary("address_book"),
          value: (item) => toInfoData(item, "address_books", null),
          sortable: false,
        },
        {
          key: "document_counter",
          label: this.getDictionary("Documenti"),
          value: (item) => (item.documents.length ? item.documents.length : 0),
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
          value: (item) =>
            item.tasks.length
              ? item.tasks.filter((task) => task.task_type.value === 2).length
              : 0,
          sortable: false,
        },
        {
          key: "todo_counter",
          label: this.getDictionary("Attività"),
          value: (item) =>
            item.tasks.length
              ? item.tasks.filter((task) => task.task_type.value === 1).length
              : 0,
          sortable: false,
        },
        {
          key: "appointment_counter",
          label: this.getDictionary("Appuntamenti"),
          value: (item) =>
            item.tasks.length
              ? item.tasks.filter((task) => task.task_type.value === 0).length
              : 0,
          sortable: false,
        },
      ],
      group_data: null,
      extra_group_full_info: null,
      form: {
        inpt_label_group: "",
        quick_value: "",
      },
      filterLabels: {
        "byRegistry.title": "Nominativo",
        "byAttribute.status_registry": "Tipo Cliente",
        "byBroker.id": "Produttore",
      },
    };
  },
  // props: {
  //   show: {
  //     type: Boolean,
  //     default: true,
  //   },
  // },
  provide() {
    // use function syntax so that we can access `this`
    return {
      args: computed(() => this.args),
    };
  },
  components: {
    BaseCheckbox,
    BaseIcon,
    BaseInput,
    BaseSelect,
    BaseTextarea,
    TableRegistries,
    // ButtonGroupTable,
    ExportOptions,
    CustomFilter,
    QuickSearchGroupModal,
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
    // if (!this.hasLoadedResource("mandate_codes"))
    //   this.getResources("auth/mandate_codes");
    // console.log("index");
    // debugger;
    // this.isLoading = false;
  },
  watch: {
    activeBrokerOnly(val) {
      if (val) {
        this.filter.byInsuranceStatus.value = null;
      }
    },
  },
  mounted() {
    this.salesmen = this.getSalesmen();
    this.activeFilters = {};
    this.activeFilters = this.retriveActiveFilters();
    // this.open_filter = this.countActiveFilters ? false : true;
    // debugger;
    // const shouldOpenSidebar = this.areActiveFiltersOnlyDefault();
    // console.log("shouldOpenSidebar", shouldOpenSidebar);
    // this.open_filter = this.countActiveFilters ? false : true;
    // this.open_filter = this.areActiveFiltersOnlyDefault();
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("mandate_codes"))
      resources.push(
        this.$store
          .dispatch(`${path}mandate_codes`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("councils"))
      // this.getResources("auth/councils");
      // resources.push({
      //   path: path,
      //   value: "councils",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("provinces"))
      // this.getResources("auth/provinces");
      // resources.push({
      //   path: path,
      //   value: "provinces",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            // const defaultCountryId = this.getCountries().find(
            //   (country) => country.text == this.defaultCountryName
            // ).value;
            // this.opt_provinces = this.getProvinces()(defaultCountryId);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    } else {
      const defaultCountryId = this.getCountries().find(
        (country) => country.text == this.defaultCountryName,
      ).value;
      this.opt_provinces = this.getProvinces()(defaultCountryId);
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          const defaultCountryId = this.getCountries().find(
            (country) => country.text == this.defaultCountryName,
          ).value;
          this.opt_provinces = this.getProvinces()(defaultCountryId);
          // this.isLoading = false;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          // this.isLoading = false;
          // this.$emit("storageLoading", false);
        });
    } else {
      this.isLoading = false;
      // this.$emit("storageLoading", false);
    }
    /* */
    // const defaultCountryId = this.getCountries().find(
    //   (country) => country.text == this.defaultCountryName
    // ).value;
    // this.opt_provinces = this.getProvinces()(defaultCountryId);
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computeActiveFilters() {
      return this.retriveActiveFilters();
    },
    computeLisaLexDomain() {
      return process.env.VUE_APP_LISALEX;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    getDictionary,
    toInfoData,
    isAdmin,
    getInputType,
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllBrokers() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    computeFilterName(name) {
      // return this.filterLabels[name];
      if (!name) return "-";
      return this.getDictionary(name, "filters");
    },
    computeFilterValue(name, value) {
      // return this.filterLabels[name];
      /* */
      let ret;
      switch (name) {
        case "byAttribute.status_registry":
          ret = this.statusRegistryOptions.find(
            (el) => el.value === value,
          ).text;
          break;
        case "byBroker.id":
          if (isNaN(value)) {
            ret = value;
          } else {
            ret = this.salesmen.find((el) => el.value === value).text;
          }
          break;
        default:
          ret = "";
          break;
      }
      /* */
      if (!ret && !name) return "-";
      if (ret) return ret;
      ret = this.getDictionary(`${name}.${value}`, "filters");
      return ret ? ret : value;
    },
    // clearSingleFilter(result, parentLevel, lastKey) {
    // clearSingleFilter(parts) {
    //   debugger;
    //   if (!parts || !parts?.length) return;

    //   // if (!result || !parentLevel || !lastKey) return;
    //   // parentLevel[lastKey] = null;
    // },
    resetSingleFilter(name) {
      // debugger;
      let res = true;
      // Split the string into parts by the `dot`
      const parts = name.split(".");

      // Traverse the allowedKeys object according to the parts
      // let currentLevel = this.filter;
      // let parentLevel = null;
      // let lastKey = null;

      // for (const part of parts) {
      //   // Check if the current part exists in the current level
      //   if (!currentLevel || !(part in currentLevel)) {
      //     res = false; // Part is not valid
      //   }
      //   parentLevel = currentLevel; // Save the current level for modification
      //   lastKey = part; // Save the current key
      //   currentLevel = currentLevel[part]; // Move to the next level
      // }

      // this.clearSingleFilter(res, parentLevel, lastKey);

      // Set the value to null at the final level
      // if (parentLevel && lastKey) {
      //   parentLevel[lastKey] = null;
      // }

      // return true; // All parts are valid

      // // Traverse the allowedKeys object according to the parts
      let currentLevel = this.filter;
      for (const part of parts) {
        // Check if the current part exists in the current level
        if (!currentLevel || !(part in currentLevel)) {
          res = false; // Part is not valid
        }
        currentLevel = currentLevel[part]; // Move to the next level
      }
      // debugger;

      // res = true; // All parts are valid
      if (!res) return;
      // this.clearSingleFilter(parts);
      // const splitted = this.splitByLastDot(name);
      // if (!splitted.length) return;
      this.accessNestedFilterOption(name);
      // const access = this.accessNestedFilterOption(splitted);
      // console.log(access);
      // if (!access || !Object.keys(access).length) return;
      // // debugger;
      // access[splitted[1]] = null;

      // console.log("res", res);
    },
    splitByLastDot(str) {
      const lastDotIndex = str.lastIndexOf(".");
      if (lastDotIndex === -1) {
        return [str]; // No dots found, return the whole string
      }
      return [str.slice(0, lastDotIndex), str.slice(lastDotIndex + 1)];
    },
    accessNestedFilterOption(name) {
      const splitted = this.splitByLastDot(name);
      if (!splitted.length) return;
      const access = splitted[0].split(".").reduce((o, i) => o[i], this.filter);
      if (!access || !Object.keys(access).length) return;
      access[splitted[1]] = null;
      if (name === "byActiveBroker.id") {
        this.activeBrokerOnly = false;
      }
      console.log("this.filter", this.filter);
      console.log("access", access);
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      this.onSearch(this.filterName);
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byActiveBroker") {
          const hasValue =
            value &&
            value.id &&
            (Array.isArray(value.id) ? value.id.length > 0 : true);
          if (hasValue) {
            this.activeFilters["byActiveBroker.id"] = "Si";
          } else {
            delete this.activeFilters["byActiveBroker.id"];
          }
        } else if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    initFilter() {
      let init = {
        byAttribute: {
          id: null,
          pk: null,
          sk: null,
          status_registry: null,
          NAME: null,
          SURN: null,
          CNAM: null,
          NINO: null,
          CREG: null,
          GDPR: null,
          PROF: null,
        },
        byBroker: {
          id: null,
        },
        byActiveBroker: {
          id: null,
        },
        byPrivacy: null,
        byRegistryGroup: {
          code: null,
        },
        byRegistry: {
          title: null,
        },
        byTask: {
          task_type: null,
        },
        byCorrespondence: {
          ZIPC: null,
          CITY: null,
        },
        byInsuranceStatus: {
          value: null,
        },
        byManual: null,
        byCouncil: {
          id: null,
        },
        byCustom: {
          ADDR: {
            value: null,
            likewise: 4,
            filter: "byCorrespondence",
          },
        },
        byProvince: {
          id: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "attributables") {
      return `${prefix}.${key}`;
    },
    onEdit(id, item) {
      this.$router.push({
        name: "registries.edit",
        params: { id: `${id}`, item: item },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Anagrafica eliminata con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSearch(name) {
      this.filter.byActiveBroker.id = this.activeBrokerOnly
        ? this.filter.byBroker.id
        : null;
      this.performedSearch = true;
      /* */
      // this.activeFilters = this.computeActiveFilters;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      /* */
      let criteria = this.filter;
      // store the filter
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      /* */
      criteria = {};

      ["quickSearchGroup"].forEach((element) => {
        criteria[element] = {
          label: "",
          formLabel: "",
          data: null,
          formData: null,
        };
      });
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      /* */
      this.removePaginationByName(name);
      // fetch data
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.activeBrokerOnly = false;
      this.resetGroupId();
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeFilterExtraGroupByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSelectProvince(selected) {
      this.opt_councils = this.getCouncils()(selected);
      this.filter.byCorrespondence.CITY = null;
    },
    onRemoveProvince() {
      this.opt_councils = [];
      this.filter.byCorrespondence.CITY = null;
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
      removeFilterExtraGroupByName: "removeExtraGroupByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getProvinces: "provinces",
      getCouncils: "councils",
      getCountries: "countries",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
};
</script>
